import React, { useState } from 'react';
import './StyleSheets/App.css';
import MainDashboard from './Components/MainDashboard';
import Loader from './Components/Loader';

import { defaults } from 'react-chartjs-2';
import { isMobile, deviceType } from 'react-device-detect';

import appIcon from './Graphics/Icons/corona_metrics_app_icon.png';

// import ColorGuidHelper from './Components/helpers/ColorGuideHelper';
import tinygradient from 'tinygradient';

import coronaData from './Data/LatestData.json'; //local data for backup

const queryString = window.location.search;
const urlParams = new URLSearchParams( queryString );

const coronaDataUrl = urlParams.get('dataUrl');
const defaultDataUrl = "https://horizon.kayma.com/data/covid.kayma.com/data.json";

const appSettings = {
  colors: ["#111111","#FFFFFF","#F2B42A","#E03636","#3799DD","#FF826E","#70621D","#5F1BE2","#6AD3AA","#774031","#ED5883","#E27A24","#935CB7","#4FE8D9","#C1BE59","#722B68","#306B53","#FF99DD","#130F60"],
  dailyMeasuresKeys:["coronavirus_cases_total","deaths_total","recovered_total","daily_tests","average_temp","exchange_rate"],
  policyEventsKeys: ["restrictions_work_places_private_sector_level","public_gathering_restrictions_level","confinement_level","retail_restrictions_level","public_transportation_restrictions_level","educational_institutions_restrictions_level","land-sky_borders_level","isolated_people_management_level","elderly_isolation_level" ],
  economicPolicyKeys: ["total_packages_value_in_one_billion_dollars","tax_binary","credit_measures_binary","direct_transfers_binary","labor_market_employees_binary","laber_market_employers_binary","govt_budget_restrictions_binary","public_expenditure_increase_binary","health_expenditures_binary","other_binary"],
  severityGradient: {},
}

function fetchJson( url, cb, err ) {
  fetch( url )
  .then( response => response.json() )
  .then( jsonData => cb( jsonData ) )
  .catch( error => { 
    console.error( "Failed to fetch JSON from url. Details: " + error ); 
    err( error );
  });
}

function App() {

  defaults.global.defaultFontFamily = 'simplerReg';
  defaults.global.animation.duration = 700;

  appSettings.severityGradient = tinygradient([ {color: appSettings.colors[1], pos: 0},
  {color: appSettings.colors[2], pos: 0.5},
  {color: appSettings.colors[3], pos: 1}]);

  global.getSeverityColor = function (s) {
    return appSettings.severityGradient.rgbAt( (s - 1) / 2 );
  }

  //Generate more colors in case more countries are added:
  for( let i=0; i< 30; i++) { appSettings.colors.push( getRandomColor() ) }
  
  const [covidDataFromUrl, setCovidDataFromUrl] = useState(undefined);
  const [isDataReady, setIsDataReady] = useState(false);

  if( covidDataFromUrl === undefined ) {

    if( coronaDataUrl ) {
      // try fetching json from url:
      fetchJson( coronaDataUrl,
          res => { 
            setCovidDataFromUrl( res );
            setIsDataReady( true );
          },
          err => { 
            // in case something went wrong, try the default url:
            fetchJson( defaultDataUrl, 
              resDef => {
                setCovidDataFromUrl( resDef );
                setIsDataReady( true );
              }, errDef => { setIsDataReady( true ); } );
          } 
        );
    } else {
      // if current url is not specified, try the default url:
      fetchJson( defaultDataUrl, 
        resDef => { 
          setCovidDataFromUrl( resDef );
          setIsDataReady( true ); 
        }, errDef => { setIsDataReady( true ); } ); 
    }
  }

  return (
    isMobile && deviceType !== "tablet" ? 
      <div id="mobileDeviceMessageCont"> 
          <img key="app_icon" src={appIcon} alt="corona_metrics_icon" id="coronaMetricsAppIcon_m"
                    onClick ={()=> {this.setState({isBarOpen: !this.state.isBarOpen}); }}
                />
          <h3>האתר אינו תומך במכשירים ניידים.<br/> יש להיכנס דרך מחשב.</h3>
      </div>
      :
      <div className="App">
        {/* <ColorGuidHelper settings={appSettings}/> */}
          <MainDashboard appSettings={appSettings} coronaData={ covidDataFromUrl ? covidDataFromUrl : coronaData }/>
          { !isDataReady ? <Loader/> : null }
        }

      </div>
    
  );
}

function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

global.addDays = function (date, days) {
  var result = new Date(date);
  result.setDate(date.getDate() + days);
  return result;
}

export default App;

